// Import Stylesheet
import '../scss/main.scss';

// Bootstrap Components
import Alert from 'bootstrap/js/dist/alert';
import Button from 'bootstrap/js/dist/button';
import Carousel from 'bootstrap/js/dist/carousel';
import Collapse from 'bootstrap/js/dist/collapse';
import Dropdown from 'bootstrap/js/dist/dropdown';
import Modal from 'bootstrap/js/dist/modal';
import Offcanvas from 'bootstrap/js/dist/offcanvas';
import Popover from 'bootstrap/js/dist/popover';
import Scrollspy from 'bootstrap/js/dist/scrollspy';
import Tab from 'bootstrap/js/dist/tab';
import Toast from 'bootstrap/js/dist/toast';
import Tooltip from 'bootstrap/js/dist/tooltip';

// Custom Components
import NavbarHoverOpener from'./modules/navbarHoverOpener';
import youTubeConsentModalLabels from'./modules/youtubeConsentLabels';
import YoutubeConsent from'./modules/youtubeConsent';
import vimeoConsentModalLabels from'./modules/vimeoConsentLabels';
import VimeoConsent from'./modules/vimeoConsent';

// init YouTube consent
const youTubeConsentOptions = {localeDefault: 'en', locales: youTubeConsentModalLabels};
const myYouTubeConsent = new YoutubeConsent(youTubeConsentOptions);

// init Vimeo consent
const vimeoConsentOptions = {localeDefault: 'en', locales: vimeoConsentModalLabels};
const myVimeoConsent = new VimeoConsent(vimeoConsentOptions);